import { render, staticRenderFns } from "./SubjectUser.vue?vue&type=template&id=d5bef786&scoped=true"
import script from "./SubjectUser.ts?vue&type=script&lang=ts&external"
export * from "./SubjectUser.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-user.scss?vue&type=style&index=0&id=d5bef786&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bef786",
  null
  
)

export default component.exports